define('models/payment/membership-plan',[
    'underscore',
    'backbone',
    // services
    'services/api',
], function(
    _, Backbone, API
) {

    var MMembershipPlan = Backbone.Epoxy.Model.extend({
        idAttribute: 'id',

        getName: function() {
            return this.get('name');
        },
        
        getMaxMembers: function() {
            return this.get('max_members');
        },

        getMaxCoaches: function() {
            return this.get('max_coaches');
        },

        getCurrencies: function() {
            return this.get('currencies');
        },
    });

    // Return the model for the module
    return MMembershipPlan;
});

